/** @format */
import { LoadingButton as MuiLoadingButton } from '@mui/lab';
import {
  Grid as MuiGrid,
  TextField as MuiTextField
} from '@mui/material';
import styled from 'styled-components';

// Styled Components
export const StyledGrid = styled(MuiGrid)`
  margin-bottom: ${({ theme }) => theme.spacing(0)};
  padding-top: ${({ theme }) => theme.spacing(0)};
`;

export const StyledTextField = styled(MuiTextField)`
  & .MuiInputBase-root {
  
  }
`;

export const StyledLoadingButton = styled(MuiLoadingButton)`
  margin-top: ${({ theme }) => theme.spacing(0)};
  &.Mui-disabled {
    background-color: ${({ theme }) => theme.palette.action.disabled};
  }
`;

export const VerificationButton = styled(StyledLoadingButton)`
  &.MuiButton-root {
    background-color: ${({ theme }) => theme.palette.info.main};
    &:hover {
      background-color: ${({ theme }) => theme.palette.info.dark};
    }
  }
`;

export const SearchButton = styled(StyledLoadingButton)`
  padding: ${({ theme }) => theme.spacing(1)};
  margin-right: ${({ theme }) => theme.spacing(-1.3)};
`;

export const StartOverButton = styled(StyledLoadingButton)`
  padding: ${({ theme }) => theme.spacing(1)};
  margin-left: ${({ theme }) => theme.spacing(2)};
`;